// export default 'http://localhost:3332' // local 

// export default process.env.REACT_APP_IP || 'https://api-gofit.solvel.tech'
export default process.env.REACT_APP_IP || 'http://localhost:3002'
// export default 'https://api-fitfollow.solvel.tech'